<section class="country-selector m-0" cdkTrapFocus cdkTrapFocusAutoCapture>
  <ng-container *ngIf="isMobile">
    <div class="mobile-select-header">
      <header>Language Select</header>
      <span tabindex="0" aria-label="Close" role="button" class="close-icon" (accessibleClick)="closed.emit(true)">
        <mat-icon>close</mat-icon>
      </span>
    </div>
    <mat-divider class="heading-divider"></mat-divider>
  </ng-container>
  <div class="input-selector-search">
    <mat-form-field appearance="outline">
      <input
        id="set-site"
        matInput
        type="text"
        aria-labelledby="country-lang-selector"
        [(ngModel)]="searchText"
        placeholder="Search country/language"
      />
    </mat-form-field>
    <div class="selected-site" tabindex="0">
      <span *ngIf="showGlobeIcon"><mat-icon class="globe-icon" fontIcon="language"></mat-icon></span>
      <span *ngIf="!showGlobeIcon" class="fi fi-{{ (init | async)?.display_country_code | lowercase }} fis"></span>
      <span class="selected-country py-0" (click)="$event.stopPropagation()">{{ (init | async)?.display_name }}</span>
      <span class="selected"></span>
    </div>
    <mat-divider></mat-divider>
  </div>
  <div class="site-options">
    <ul>
      <li
        role="link"
        [class.selected-link]="(init | async)?.site_id === site?.site_id"
        [class.no-flag-icon]="showGlobeIcon"
        [class.no-flag-icon-selected]="showGlobeIcon && (init | async)?.site_id === site?.site_id"
        *ngFor="let site of sites | async | filter: filterSite : searchText"
        tabindex="0"
        (accessibleClick)="!isMobile ? setSite(site) : tempSite(site)"
      >
        <span *ngIf="!showGlobeIcon" class="fi fi-{{ site?.display_country_code | lowercase }} fis"></span>
        <span [class.px-0]="showGlobeIcon" class="country-name">{{ site?.display_name }}</span>
        <span
          *ngIf="(init | async)?.site_id === site?.site_id"
          [class.selected]="(init | async)?.site_id === site?.site_id"
        ></span>
      </li>
    </ul>
  </div>
</section>
<div *ngIf="isMobile" role="group" class="country-selector-button-group">
  <button aria-label="cancel" class="cancel-button mr-1" mat-raised-button color="secondary" (click)="onCancel()">
    {{ 'PeopleSelectorComponent:Cancel' | translate }}
  </button>
  <button aria-label="apply" class="apply-button ml-1" mat-flat-button color="accent" (click)="setSite()">
    {{ 'RoomSelectorComponent:Apply' | translate }}
  </button>
</div>
